import classNames from 'classnames';
import { uniqueId } from 'lodash';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormGroup, Input, Label, UncontrolledTooltip } from 'reactstrap';

import FormField from '../../../models/FormField';
import { modelOf } from '../../../prop-types';
import Icon from '../../common/Icon';
import Field from '../Field';
import FieldError from '../FieldError';

@observer
class FormGroupField extends Component {
  constructor(props) {
    super(props);
    const { formName, fieldName } = props;
    // In the normal use cases, the form and field names don't change, and
    // this only really affects the input/label binding, so not updating the id
    // afterwards if props change should still be fine.
    this.id = uniqueId(`${formName}__${fieldName}--`);
  }

  getTooltip = (text) => {
    return (
      <>
        <Icon name="info" className={`tooltip-${this.id}`} />
        <UncontrolledTooltip target={`.tooltip-${this.id}`}>
          {text}
        </UncontrolledTooltip>
      </>
    );
  };

  render() {
    const {
      label,
      fieldName,
      field,
      type,
      hideLabel,
      required,
      tooltip,
      description,
      formGroupClassName,
      // unused, but no reason to pass to Field with rest
      formName,
      ...rest
    } = this.props;
    return (
      <FormGroup className={classNames('FormGroupField', formGroupClassName)}>
        <Label for={this.id} hidden={hideLabel}>
          {required && <span className="FormGroupField__required-mark">*</span>}
          {label}
          {tooltip && this.getTooltip(tooltip)}
        </Label>
        <Field
          component={Input}
          field={field}
          type={type}
          name={fieldName}
          id={this.id}
          required={required}
          {...rest}
        />
        {description}
        <FieldError field={field} />
      </FormGroup>
    );
  }
}

FormGroupField.propTypes = {
  field: modelOf(FormField).isRequired,
  formName: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  formGroupClassName: PropTypes.string,
  type: PropTypes.string,
  tooltip: PropTypes.string,
  hideLabel: PropTypes.bool,
  required: PropTypes.bool,
  description: PropTypes.node,
};

FormGroupField.defaultProps = {
  type: 'text',
};

export default FormGroupField;
